var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 5.1665V8.6665",
    stroke: "#E1631E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.21 5.72019V10.2802C14.21 11.0268 13.81 11.7202 13.1634 12.1002L9.20337 14.3869C8.5567 14.7602 7.75669 14.7602 7.10335 14.3869L3.14335 12.1002C2.49668 11.7269 2.09668 11.0335 2.09668 10.2802V5.72019C2.09668 4.97352 2.49668 4.28016 3.14335 3.90016L7.10335 1.6135C7.75002 1.24016 8.55004 1.24016 9.20337 1.6135L13.1634 3.90016C13.81 4.28016 14.21 4.96685 14.21 5.72019Z",
    stroke: "#E1631E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 10.7998V10.8665",
    stroke: "#E1631E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostWarning);
export default __webpack_public_path__ + "static/media/postWarning.8b70a27c.svg";
export { ForwardRef as ReactComponent };